module.exports = __webpack_public_path__ + "static/img/wla.d116976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/wla.jpg
// module id = BR+F
// module chunks = 0